module.exports = __webpack_public_path__ + "img/小logo.84d1b952.png";